import { CarbonTrackApi } from '@core/api/model/sustainability/carbon-track-api.model';
import { CarbonTrack } from '../../model/sustainability/carbon-track.model';
import { RequestResponse } from '@core/services/request/model/request.model';

export class CarbonTrackMapper {
  static requestFromApiToDomain(input: RequestResponse<CarbonTrackApi>): RequestResponse<CarbonTrack> {
    return {
      ...input,
      data: CarbonTrackMapper.fromApiToDomain(input.data),
    };
  }

  static fromApiToDomain(api: CarbonTrackApi): CarbonTrack {
    return {
      totalConsumption: api.totalConsumo,
      emissionsAvoided: api.emisionesEvitadas,
      numCarsRemoved: api.numCochesRetirados,
      numTreesPlanted: api.numArbolesPlantados,
      emissionsAvoidedEmployees: api.emisionesEvitadasEmpleados,
    };
  }
}
